import { Fragment, useEffect, useState } from "react";
import { ProfesionalActivo } from "../../../../models/profesional-activo";
import { profesionalServices } from "../../../../services/profesional.services";
import "./portal-profesionales.scss";

export default function Profesionales() {
  const [profesionalesData, setProfesionalesData] = useState<
    ProfesionalActivo[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    profesionalServices
      .activos()
      .then((res) => {
        setProfesionalesData(res.data);
      })
      .catch(() => {
        setError(
          "No se pudieron cargar los profesionales. Intente nuevamente."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const [filtroNombre, setFiltroNombre] = useState("");
  const [filtroLocalidad, setFiltroLocalidad] = useState("");
  const [filtroObraSocial, setFiltroObraSocial] = useState("");
  const [filtroArea, setFiltroArea] = useState("");
  const [filtroPoblacion, setFiltroPoblacion] = useState("");

  const localidades = Array.from(
    new Set(profesionalesData.map((p) => p.localidadLaboral))
  );
  const areas = [
    "Audición",
    "Vestibular",
    "Comunicación y lenguaje",
    "Habla",
    "Neurorehabilitación",
    "Voz",
    "Motricidad orofacial",
  ];

  const poblaciones = [
    "Recién nacidos",
    "Niños/as",
    "Adolescentes",
    "Adultos",
    "Adultos mayores",
  ];

  const profesionalesFiltrados = profesionalesData.filter((p) => {
    const nombreCompleto = `${p.nombre} ${p.apellido}`.toLowerCase();
    const matchNombre =
      nombreCompleto.includes(filtroNombre.toLowerCase()) ||
      p.matriculaProf.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad =
      !filtroLocalidad || p.localidadLaboral === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === "si" && p.atiendePorObraSocial) ||
      (filtroObraSocial === "no" && !p.atiendePorObraSocial);
    const matchArea = !filtroArea || (p.areas ?? []).includes(filtroArea);
    const matchPoblacion =
      !filtroPoblacion || (p.poblacion ?? []).includes(filtroPoblacion);
    return (
      matchNombre &&
      matchLocalidad &&
      matchObraSocial &&
      matchArea &&
      matchPoblacion
    );
  });

  const toTitleCase = (str: string) =>
    str
      .toLowerCase()
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  const getRed = (redes: string[], red: string) =>
    redes.find((url) => url.toLowerCase().includes(red)) ?? null;

  const redStyle = (bg: string, size: number): React.CSSProperties => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: "50%",
    background: bg,
    color: "white",
    textDecoration: "none",
  });

  return (
    <div className="profesionales-container">
      <div className="profesionales">
        <div
          id="profesionales"
          className="professionals section"
          style={{
            background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
            padding: "80px 0",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "300px",
              height: "300px",
              background:
                "linear-gradient(135deg, rgba(71,85,105,0.1), rgba(100,116,139,0.1))",
              borderRadius: "50%",
              zIndex: 1,
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "-100px",
              left: "-100px",
              width: "400px",
              height: "400px",
              background:
                "linear-gradient(135deg, rgba(100,116,139,0.1), rgba(51,65,85,0.1))",
              borderRadius: "50%",
              zIndex: 1,
            }}
          />

          <div
            className="container"
            style={{ position: "relative", zIndex: 2 }}
          >
            {loading && (
              <div className="text-center py-5">
                <div
                  className="spinner-border"
                  style={{ color: "#06b6d4" }}
                  role="status"
                >
                  <span className="visually-hidden">Cargando...</span>
                </div>
                <p
                  style={{
                    color: "#64748b",
                    marginTop: "15px",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  Cargando profesionales...
                </p>
              </div>
            )}

            {error && (
              <div className="text-center py-5">
                <i
                  className="bi bi-exclamation-triangle"
                  style={{ fontSize: "3rem", color: "#f59e0b" }}
                ></i>
                <p
                  style={{
                    color: "#64748b",
                    marginTop: "15px",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  {error}
                </p>
              </div>
            )}

            {!loading && !error && (
              <>
                <div className="container section-title fade-up text-center mb-5">
                  <h2>Nuestros Profesionales</h2>
                  <p>
                    Encuentre profesionales matriculados especializados en
                    fonoaudiología
                  </p>
                </div>

                <div className="row mb-5">
                  <div className="col-12">
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                        backdropFilter: "blur(15px)",
                        borderRadius: "20px",
                        padding: "30px",
                        border: "1px solid rgba(255,255,255,0.3)",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                      }}
                    >
                      <div className="row g-3">
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-person me-2"
                              style={{ color: "#06b6d4" }}
                            ></i>
                            Nombre o matrícula
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre o N° de matrícula"
                            value={filtroNombre}
                            onChange={(e) => setFiltroNombre(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(6,182,212,0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255,255,255,0.8)",
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-geo-alt me-2"
                              style={{ color: "#10b981" }}
                            ></i>
                            Localidad
                          </label>
                          <select
                            className="form-select"
                            value={filtroLocalidad}
                            onChange={(e) => setFiltroLocalidad(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(16,185,129,0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255,255,255,0.8)",
                            }}
                          >
                            <option value="">Todas las localidades</option>
                            {localidades.map((loc) => (
                              <option key={loc} value={loc}>
                                {loc}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-heart-pulse me-2"
                              style={{ color: "#14b8a6" }}
                            ></i>
                            Obra Social
                          </label>
                          <select
                            className="form-select"
                            value={filtroObraSocial}
                            onChange={(e) =>
                              setFiltroObraSocial(e.target.value)
                            }
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(20,184,166,0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255,255,255,0.8)",
                            }}
                          >
                            <option value="">Todos</option>
                            <option value="si">Atiende Obra Social</option>
                            <option value="no">No atiende Obra Social</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-bookmark me-2"
                              style={{ color: "#0ea5e9" }}
                            ></i>
                            Área
                          </label>
                          <select
                            className="form-select"
                            value={filtroArea}
                            onChange={(e) => setFiltroArea(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(14,165,233,0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255,255,255,0.8)",
                            }}
                          >
                            <option value="">Todas las áreas</option>
                            {areas.map((area) => (
                              <option key={area} value={area}>
                                {area}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#374151",
                              fontSize: "0.9rem",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <i
                              className="bi bi-people me-2"
                              style={{ color: "#8b5cf6" }}
                            ></i>
                            Población
                          </label>
                          <select
                            className="form-select"
                            value={filtroPoblacion}
                            onChange={(e) => setFiltroPoblacion(e.target.value)}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid rgba(139,92,246,0.3)",
                              padding: "12px 16px",
                              fontSize: "0.95rem",
                              background: "rgba(255,255,255,0.8)",
                            }}
                          >
                            <option value="">Todas las poblaciones</option>
                            {poblaciones.map((pob) => (
                              <option key={pob} value={pob}>
                                {pob}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    {profesionalesFiltrados.length === 0 ? (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                          backdropFilter: "blur(15px)",
                          borderRadius: "20px",
                          padding: "60px 40px",
                          border: "1px solid rgba(255,255,255,0.3)",
                          boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                          textAlign: "center",
                        }}
                      >
                        <i
                          className="bi bi-search"
                          style={{
                            fontSize: "3rem",
                            color: "#94a3b8",
                            marginBottom: "20px",
                          }}
                        ></i>
                        <h4
                          style={{
                            color: "#64748b",
                            fontFamily: "'Poppins', sans-serif",
                            marginBottom: "10px",
                          }}
                        >
                          No se encontraron profesionales
                        </h4>
                        <p style={{ color: "#94a3b8", fontSize: "1rem" }}>
                          Intenta ajustar los filtros de búsqueda
                        </p>
                      </div>
                    ) : (
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                          backdropFilter: "blur(15px)",
                          borderRadius: "20px",
                          border: "1px solid rgba(255,255,255,0.3)",
                          boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                          overflow: "hidden",
                        }}
                      >
                        {/* Header desktop */}
                        <div className="d-none d-lg-block">
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "200px 180px 100px 160px 140px 110px 150px",
                              gap: "16px",
                              padding: "25px 30px",
                              background:
                                "linear-gradient(135deg, rgba(6,182,212,0.1), rgba(16,185,129,0.05))",
                              borderBottom: "1px solid rgba(6,182,212,0.2)",
                              fontFamily: "'Poppins', sans-serif",
                              alignItems: "center",
                            }}
                          >
                            {[
                              {
                                icon: "bi-person-circle",
                                color: "#06b6d4",
                                label: "Profesional",
                              },
                              {
                                icon: "bi-geo-alt",
                                color: "#10b981",
                                label: "Domicilio Laboral",
                              },
                              {
                                icon: "bi-card-text",
                                color: "#0ea5e9",
                                label: "Matrícula",
                              },
                              {
                                icon: "bi-bookmark",
                                color: "#8b5cf6",
                                label: "Áreas",
                              },
                              {
                                icon: "bi-people",
                                color: "#a855f7",
                                label: "Población",
                              },
                              {
                                icon: "bi-heart-pulse",
                                color: "#f59e0b",
                                label: "Obra Social",
                              },
                              {
                                icon: "bi-share",
                                color: "#ef4444",
                                label: "Redes",
                              },
                            ].map(({ icon, color, label }) => (
                              <div
                                key={label}
                                style={{
                                  fontWeight: "600",
                                  color: "#1e293b",
                                  fontSize: "0.9rem",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <i
                                  className={`bi ${icon} me-2`}
                                  style={{ color }}
                                ></i>
                                {label}
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Filas */}
                        <div>
                          {profesionalesFiltrados.map((profesional, idx) => {
                            const nombreCompleto = `${profesional.apellido.toUpperCase()} ${toTitleCase(profesional.nombre)}`;
                            const twitter = getRed(profesional.redes, "x.com");
                            const facebook = getRed(
                              profesional.redes,
                              "facebook"
                            );
                            const instagram = getRed(
                              profesional.redes,
                              "instagram"
                            );
                            const linkedin = getRed(
                              profesional.redes,
                              "linkedin"
                            );
                            const borderBottom =
                              idx < profesionalesFiltrados.length - 1
                                ? "1px solid rgba(226,232,240,0.6)"
                                : "none";

                            return (
                              <Fragment key={profesional.id}>
                                {/* Desktop */}
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      "200px 180px 100px 160px 140px 110px 150px",
                                    gap: "16px",
                                    padding: "20px 30px",
                                    borderBottom,
                                    transition: "all 0.3s ease",
                                    fontFamily: "'Inter', sans-serif",
                                    fontSize: "0.9rem",
                                    alignItems: "center",
                                  }}
                                  className="professional-table-row d-none d-lg-grid"
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background =
                                      "rgba(6,182,212,0.05)";
                                    e.currentTarget.style.transform =
                                      "translateX(5px)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background =
                                      "transparent";
                                    e.currentTarget.style.transform =
                                      "translateX(0)";
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "45px",
                                        height: "45px",
                                        background:
                                          "linear-gradient(135deg,#06b6d4,#10b981)",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow:
                                          "0 4px 15px rgba(6,182,212,0.3)",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <i
                                        className="fas fa-user-md"
                                        style={{
                                          fontSize: "1.1rem",
                                          color: "white",
                                        }}
                                      ></i>
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontWeight: "600",
                                          color: "#1e293b",
                                          fontSize: "0.95rem",
                                          lineHeight: "1.2",
                                        }}
                                      >
                                        {nombreCompleto}
                                      </div>
                                      <div
                                        style={{
                                          color: "#64748b",
                                          fontSize: "0.8rem",
                                        }}
                                      >
                                        {profesional.localidadLaboral}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      color: "#64748b",
                                      lineHeight: "1.4",
                                      fontSize: "0.85rem",
                                    }}
                                  >
                                    {profesional.domicilioLaboral}
                                  </div>
                                  <div
                                    style={{
                                      color: "#64748b",
                                      fontWeight: "500",
                                      fontSize: "0.85rem",
                                      textAlign: "center",
                                    }}
                                  >
                                    {profesional.matriculaProf}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "4px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {(profesional.areas ?? []).map((esp) => (
                                      <span
                                        key={esp}
                                        style={{
                                          background:
                                            "linear-gradient(135deg,rgba(6,182,212,0.1),rgba(16,185,129,0.1))",
                                          color: "#047857",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          fontSize: "0.7rem",
                                          fontWeight: "500",
                                          border:
                                            "1px solid rgba(6,182,212,0.2)",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {esp}
                                      </span>
                                    ))}
                                  </div>
                                  {/* Población */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "4px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {(profesional.poblacion ?? []).map(
                                      (pob) => (
                                        <span
                                          key={pob}
                                          style={{
                                            background:
                                              "linear-gradient(135deg,rgba(139,92,246,0.1),rgba(168,85,247,0.1))",
                                            color: "#7c3aed",
                                            padding: "2px 8px",
                                            borderRadius: "12px",
                                            fontSize: "0.7rem",
                                            fontWeight: "500",
                                            border:
                                              "1px solid rgba(139,92,246,0.2)",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {pob}
                                        </span>
                                      )
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {profesional.atiendePorObraSocial ? (
                                      <div
                                        style={{
                                          background:
                                            "linear-gradient(135deg,rgba(16,185,129,0.1),rgba(34,197,94,0.1))",
                                          color: "#10b981",
                                          padding: "4px 12px",
                                          borderRadius: "20px",
                                          fontSize: "0.75rem",
                                          fontWeight: "600",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          border:
                                            "1px solid rgba(16,185,129,0.2)",
                                        }}
                                      >
                                        <i className="bi bi-check-circle-fill"></i>{" "}
                                        Sí
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          background: "rgba(148,163,184,0.1)",
                                          color: "#94a3b8",
                                          padding: "4px 12px",
                                          borderRadius: "20px",
                                          fontSize: "0.75rem",
                                        }}
                                      >
                                        No
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {twitter && (
                                      <a
                                        href={twitter}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={redStyle(
                                          "linear-gradient(135deg,#1da1f2,#0d8bd9)",
                                          28
                                        )}
                                      >
                                        <i
                                          className="bi bi-twitter-x"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {facebook && (
                                      <a
                                        href={facebook}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={redStyle(
                                          "linear-gradient(135deg,#3b5998,#2d4373)",
                                          28
                                        )}
                                      >
                                        <i
                                          className="bi bi-facebook"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {instagram && (
                                      <a
                                        href={instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={redStyle(
                                          "linear-gradient(135deg,#e4405f,#c13584)",
                                          28
                                        )}
                                      >
                                        <i
                                          className="bi bi-instagram"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                    {linkedin && (
                                      <a
                                        href={linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={redStyle(
                                          "linear-gradient(135deg,#0077b5,#005885)",
                                          28
                                        )}
                                      >
                                        <i
                                          className="bi bi-linkedin"
                                          style={{ fontSize: "0.8rem" }}
                                        ></i>
                                      </a>
                                    )}
                                  </div>
                                </div>

                                {/* Mobile */}
                                <div
                                  className="d-lg-none"
                                  style={{ padding: "20px", borderBottom }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        background:
                                          "linear-gradient(135deg,#06b6d4,#10b981)",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow:
                                          "0 4px 15px rgba(6,182,212,0.3)",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <i
                                        className="fas fa-user-md"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "white",
                                        }}
                                      ></i>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                      <h5
                                        style={{
                                          fontWeight: "600",
                                          color: "#1e293b",
                                          margin: "0 0 5px 0",
                                          fontFamily: "'Poppins', sans-serif",
                                          fontSize: "1.1rem",
                                        }}
                                      >
                                        {nombreCompleto}
                                      </h5>
                                      <div
                                        style={{
                                          color: "#64748b",
                                          fontSize: "0.85rem",
                                          marginBottom: "6px",
                                        }}
                                      >
                                        <i
                                          className="bi bi-geo-alt-fill me-1"
                                          style={{ color: "#10b981" }}
                                        ></i>
                                        {profesional.domicilioLaboral}
                                      </div>
                                      <div
                                        style={{
                                          color: "#64748b",
                                          fontSize: "0.85rem",
                                        }}
                                      >
                                        <i
                                          className="bi bi-card-text me-1"
                                          style={{ color: "#14b8a6" }}
                                        ></i>
                                        Mat. {profesional.matriculaProf}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "5px",
                                      marginBottom: "12px",
                                    }}
                                  >
                                    {(profesional.areas ?? []).map((esp) => (
                                      <span
                                        key={esp}
                                        style={{
                                          background:
                                            "linear-gradient(135deg,rgba(6,182,212,0.1),rgba(16,185,129,0.1))",
                                          color: "#047857",
                                          padding: "3px 10px",
                                          borderRadius: "12px",
                                          fontSize: "0.75rem",
                                          fontWeight: "500",
                                          border:
                                            "1px solid rgba(6,182,212,0.2)",
                                        }}
                                      >
                                        {esp}
                                      </span>
                                    ))}
                                    {(profesional.poblacion ?? []).map(
                                      (pob) => (
                                        <span
                                          key={pob}
                                          style={{
                                            background:
                                              "linear-gradient(135deg,rgba(139,92,246,0.1),rgba(168,85,247,0.1))",
                                            color: "#7c3aed",
                                            padding: "3px 10px",
                                            borderRadius: "12px",
                                            fontSize: "0.75rem",
                                            fontWeight: "500",
                                            border:
                                              "1px solid rgba(139,92,246,0.2)",
                                          }}
                                        >
                                          {pob}
                                        </span>
                                      )
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      paddingTop: "12px",
                                      borderTop:
                                        "1px solid rgba(226,232,240,0.6)",
                                    }}
                                  >
                                    <div>
                                      {profesional.atiendePorObraSocial ? (
                                        <div
                                          style={{
                                            background:
                                              "linear-gradient(135deg,rgba(16,185,129,0.1),rgba(34,197,94,0.1))",
                                            color: "#10b981",
                                            padding: "4px 10px",
                                            borderRadius: "15px",
                                            fontSize: "0.7rem",
                                            fontWeight: "600",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "3px",
                                            border:
                                              "1px solid rgba(16,185,129,0.2)",
                                          }}
                                        >
                                          <i className="bi bi-check-circle-fill"></i>{" "}
                                          Obra Social
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            background: "rgba(148,163,184,0.1)",
                                            color: "#94a3b8",
                                            padding: "4px 10px",
                                            borderRadius: "15px",
                                            fontSize: "0.7rem",
                                          }}
                                        >
                                          Sin Obra Social
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{ display: "flex", gap: "6px" }}
                                    >
                                      {twitter && (
                                        <a
                                          href={twitter}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={redStyle(
                                            "linear-gradient(135deg,#1da1f2,#0d8bd9)",
                                            32
                                          )}
                                        >
                                          <i
                                            className="bi bi-twitter-x"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                      {facebook && (
                                        <a
                                          href={facebook}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={redStyle(
                                            "linear-gradient(135deg,#3b5998,#2d4373)",
                                            32
                                          )}
                                        >
                                          <i
                                            className="bi bi-facebook"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                      {instagram && (
                                        <a
                                          href={instagram}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={redStyle(
                                            "linear-gradient(135deg,#e4405f,#c13584)",
                                            32
                                          )}
                                        >
                                          <i
                                            className="bi bi-instagram"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                      {linkedin && (
                                        <a
                                          href={linkedin}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={redStyle(
                                            "linear-gradient(135deg,#0077b5,#005885)",
                                            32
                                          )}
                                        >
                                          <i
                                            className="bi bi-linkedin"
                                            style={{ fontSize: "0.9rem" }}
                                          ></i>
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          <style>{`
            .form-control:focus, .form-select:focus {
              border-color: #06b6d4 !important;
              box-shadow: 0 0 0 0.2rem rgba(6,182,212,0.25) !important;
              outline: none;
            }
            .professional-table-row:hover .bi { transform: scale(1.1); }
            @media (max-width: 768px) {
              .professionals.section { padding: 60px 0 !important; }
              .professionals h2 { font-size: 2.2rem !important; }
            }
            @media (max-width: 480px) {
              .professionals.section { padding: 40px 0 !important; }
              .professionals h2 { font-size: 1.8rem !important; }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}
